export var ovpTokenService; // eslint-disable-line import/no-mutable-exports
export function setOVPTokenService(tokenService) {
    ovpTokenService = tokenService;
}
//# sourceMappingURL=ovp.js.map